/* eslint-disable import/prefer-default-export */
export const AUTO_SAVE_DELAY = 5000;
